import { EFParams, ELocations } from '@enums/api.enum';

import { EStyles } from '@enums/style.enum';
import client from '../apiClient';

export type Location = {
	address: string;
	id: number;
	isWaitAndReturn: boolean;
	lat: number;
	lng: number;
	name: string;
	type: string;
	radius: number;
	waitingTime: number;
};

export type LocationsParams = {
	type?: string;
};

export type LocationsApiResponse = {
	records: Location[];
};

const endpoint = ELocations.endpoint;

const get = <T>({ type }: LocationsParams) => {
	const query = [EFParams.qm, EFParams.type, type].join(EStyles.emptyQuote);

	return client.get<T>(`${endpoint}${ELocations.all}${query}`);
};

export default {
	get,
};
